export default __webpack_public_path__ + "static/media/allow-facta-5.55c0d3ff.png";